import styled from 'styled-components';
import { makeStyles } from '@mui/styles';
import {
  Divider as MuiDivider,
  Select as MuiSelect,
} from '@mui/material';

export const Container = styled.div`
  flex-grow: 1;
  background-color: transparent;
`;

export const Header = styled.div`
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
  text-align: right;
  background-color: transparent;
`;

export const Center = styled.div`
  flex-grow: 1;
  padding: 20px;
  background-color: transparent;
`;

export const SotableItem = styled.div`
  width: 32.5%;
  float: left;
  margin-right: 0.8%;
`;

export const ContentCentered = styled.div`
  margin-top: 20px;
  width: 100%;
  text-align: center;
`;

export const Clearfix = styled.div`
  clear: both;
  display: table;
`;

export const Divider = styled(MuiDivider)`
  margin-top: 10px !important;
`;

export const Select = styled(MuiSelect)`
  width: 300px;
  right: 20px;
  top: 0px;
  height: 40px;
`;

export const useStyles = makeStyles(() => ({
  formControl: {
    minWidth: 120,
  },
  selectEmpty: {
    fontSize: 14,
    width: 300,
  },
}));